import {
  Home,
  ShoppingCart,
  CreditCard,
  RefreshCw,
  CalendarDays,
  Ticket,
  FileText,
  Inbox,
  Users,
  Tag,
  Settings,
} from 'lucide-react';
import type { StaticEntry } from './types';

export const navigationEntries: StaticEntry[] = [
  {
    id: 'nav-dashboard',
    label: 'Dashboard',
    icon: Home,
    path: '/',
    keywords: ['home', 'overview'],
  },
  {
    id: 'nav-checkout-pages',
    label: 'Checkout pages',
    icon: ShoppingCart,
    path: '/checkouts',
    keywords: ['pages', 'checkout'],
  },
  {
    id: 'nav-payments',
    label: 'Payments',
    icon: CreditCard,
    path: '/orders/payments',
    keywords: ['charges'],
  },
  {
    id: 'nav-subscriptions',
    label: 'Subscriptions',
    icon: RefreshCw,
    path: '/orders/subscriptions',
    keywords: ['recurring'],
  },
  {
    id: 'nav-bookings',
    label: 'Bookings',
    icon: CalendarDays,
    path: '/orders/bookings',
    keywords: [],
  },
  { id: 'nav-events', label: 'Events', icon: Ticket, path: '/events', keywords: ['tickets'] },
  {
    id: 'nav-forms',
    label: 'Forms',
    icon: FileText,
    path: '/forms',
    keywords: ['form builder'],
  },
  {
    id: 'nav-submissions',
    label: 'Submissions',
    icon: Inbox,
    path: '/submissions',
    keywords: [],
  },
  { id: 'nav-customers', label: 'Customers', icon: Users, path: '/customers', keywords: [] },
  {
    id: 'nav-coupons',
    label: 'Coupons',
    icon: Tag,
    path: '/coupons',
    keywords: ['discounts', 'promo'],
  },
  {
    id: 'nav-settings',
    label: 'Settings',
    icon: Settings,
    path: '/settings/general',
    keywords: [],
  },
];
